<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津津旅海河游船股份有限公司</div>
                  <p class="p1">
                    天津津旅海河游船股份有限公司隶属于天津旅游集团，成立于2009年7月，是新三板挂牌的水上观光客运企业（证券简称：海河游船，证券代码：870350）。
                  </p>
                  <p class="p2">
                    公司现有内河经营游船18艘，总客位数1953，员工130余人。公司经营的海河观光游依托海河综合开发，传承城市文脉，包蕴津沽风情，展现都市繁华，已成为天津旅游的代表性景点和展示天津城市风貌的标志性窗口，得到了广大游客的一致认可和赞誉。
                  </p>
                  <div class="p1">
                    公司成立以来始终以向中外游客展示美好天津为已任,全力打造海河游览精品线,2019年接待游客量近100万人次，营收7525.18万元，净利润3211.27万元。做为天津市重要的窗口接待单位,圆满完成了天津夏季达沃斯论坛、智能大会、亚布力论坛、国际行动理事会、国际院士大会及日本、英国、越南、捷克等国际首脑、政府要员等700余次省部级以上重要政治及外事接待任务,多次受到中外贵宾及市委市政府的赞誉。
                  </div>
                  <div class="p1">组织架构</div>
                  <div class="p1">
                    公司党总支委员有5名，下设4个党支部，拥有党员45人，预备党员3人。公司董事会有5名董事，监事会有3名监事。设总经理1名，副总经理2名，财务总监1名。公司下设综合办公室、财务部、市场部、安全运营管理部四个职能部门，拥有天石舫码头、大悲院码头、古文化街码头、意风区码头、天津站码头、利顺德码头、宁波道码头等多座运营接待码头。
                  </div>
                  <div class="p1">经营码头地址：</div>
                  <div class="p1">
                    1、大悲院码头：河北区李公祠大街，近永乐桥天津之眼摩天轮
                  </div>
                  <div class="p1">
                    2、古文化街码头：南开区张自忠路古文化街亲水平台左转200米处，近狮子林桥
                  </div>
                  <div class="p1">
                    3、天津站码头：天津火车站前广场内，解放桥旁
                  </div>
                  <div class="p1">4、意风区码头：河北区北安桥下音乐公园旁</div>
                  <div class="img1">
                    <img
                      src="@/assets/images/hhyc1.jpg"
                      alt=""
                      height="450px"
                    />
                  </div>
                  <div class="img1">
                    <img
                      src="@/assets/images/hhyc2.jpg"
                      alt=""
                      height="450px"
                    />
                  </div>
                  <div class="img1">
                    <img
                      src="@/assets/images/hhyc3.png"
                      alt=""
                      height="450px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>